import { useQuery } from '@tanstack/react-query'
import { checkoutApi } from '@/services/checkout'

export function useCheckoutSession(sessionId: string | null) {
  return useQuery({
    queryKey: ['checkout', 'session', sessionId],
    queryFn: () => checkoutApi.getSession(sessionId as string),
    enabled: !!sessionId,
    // The webhook is the source of truth; don't retry — fall back to the
    // "processing" view quickly if the read fails.
    retry: false,
  })
}
